import WebAudioEngine from './WebAudioEngine.js';
import SuperpoweredAudioEngine from './SuperpoweredAudioEngine.js';
import { getAudioEngineChoice } from './engineChoice.js';

// Selection is fixed for this page lifetime. Only the selected backend is constructed.
const SelectedEngine = getAudioEngineChoice() === 'superpowered' ? SuperpoweredAudioEngine : WebAudioEngine;
class AudioEngine extends SelectedEngine {}
export { AudioEngine };
const audioEngine = new AudioEngine();
export default audioEngine;
